import { render } from "./delete_paroisse.vue?vue&type=template&id=1ab8743a&scoped=true"
import script from "./delete_paroisse.vue?vue&type=script&lang=js"
export * from "./delete_paroisse.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=1ab8743a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab8743a"]])

export default __exports__